/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Sla_BreachedInputs */

const vi_dashboard_driver_sla_breached = /** @type {(inputs: Dashboard_Driver_Sla_BreachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trễ SLA`)
};

/**

* @param {Dashboard_Driver_Sla_BreachedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_sla_breached = /** @type {((inputs?: Dashboard_Driver_Sla_BreachedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Sla_BreachedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_sla_breached(inputs)
});